module.exports = __webpack_public_path__ + "static/img/img_logo.2c78173d.png";